import React, { useState, useRef, useEffect } from 'react';
import api from '../services/api';
import { saveMessageToSessionStorage } from '../utils/messageStorage';
import { getTime } from '../utils/mainfunction';
import Loader from "./loader";
import FileUploadPopup from "./fileUpload";
import UserAgreementPopup from "./userAgreement";
import { showInfoAlert, showErrorAlert, showConfirmAndRedirectAlert } from '../utils/alertFunction';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import VoiceInput from './voiceinput';
import '../styles/chat.css';

const Chat: React.FC = () => {
    // const [messages, setMessages] = useState<{ sender: string; text: string; time: string }[]>([]); // Mesaj listesi

    const [isAgreementAccepted, setIsAgreementAccepted] = useState<boolean>(false);

    useEffect(() => {
        // Sayfa yüklendiğinde sözleşme onayını kontrol et
        const agreementAccepted = localStorage.getItem("AgreementApprovalChat") === "true";

        setIsAgreementAccepted(agreementAccepted);

        // Sayfa yenilendiğinde sessionStorage'dan mesajları al
        const storedMessages = JSON.parse(sessionStorage.getItem('chatMessages') || '[]');
        setMessages(storedMessages);
        setTimeout(() => {
            scrollToBottom();
        }, 1000);
    }, []);

    // Sözleşme onayı değiştiğinde tetiklenecek effect
    useEffect(() => {
        const checkAgreement = () => {
            const agreementAccepted = localStorage.getItem("AgreementApprovalChat") === "true";
            setIsAgreementAccepted(agreementAccepted);
            console.log("Sözleşme durumu güncellendi:", agreementAccepted);
        };

        // localStorage'daki değişiklikleri dinle
        window.addEventListener('storage', checkAgreement);

        return () => {
            window.removeEventListener('storage', checkAgreement);
        };
    }, []);

    const [messages, setMessages] = useState<{ sender: string; text?: string | React.ReactNode; time: string; isFile?: boolean; fileName?: string }[]>([]);

    const [messageInput, setMessageInput] = useState(''); // Kullanıcının yazdığı mesaj
    const messageBoxRef = useRef<HTMLDivElement>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [inputsDisabled, setInputsDisabled] = useState(false);

    // Web Speech API için recognition nesnesini oluşturalım
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = SpeechRecognition ? new SpeechRecognition() : null;

    useEffect(() => {
        if (recognition) {
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.lang = 'tr-TR';

            recognition.onresult = (event: any) => {
                const transcript = event.results[0][0].transcript;
                console.log("Algılanan metin:", transcript);
                setMessageInput(transcript); // Input'a yaz
                if (event.results[0].isFinal) { // Konuşma bittiğinde
                    sendMessage(transcript); // Mesajı otomatik gönder
                }
            };

            recognition.onerror = (event: any) => {
                console.error('Ses tanıma hatası:', event.error);
                setIsListening(false);
            };

            recognition.onend = () => {
                setIsListening(false);
            };
        }
    }, []);

    const handleOpenPopup = () => setPopupVisible(true);
    const handleClosePopup = () => setPopupVisible(false);

    const handleUploadSuccess = (file: File) => {
        console.log("Yükleme başarılı:", file.name);

        const newMessage = {
            sender: 'user',
            text: `Dosya başarıyla yüklendi: ${file.name}`, // Dosya adı
            time: getTime(),
            isFile: true, // Bu mesajın bir dosya olduğunu belirtmek için flag
            fileName: file.name, // Dosya adını kaydet
        };
        setMessages((prevMessages) => [...prevMessages, newMessage]);

        const aiMessage = { sender: 'ai', text: "HappAI hangi sonuç fonksiyonuna hoşgeldin.Bana sonucunla ilgili bilmek istediklerini sorabilirsin", time: getTime() };

        setMessages((prevMessages) => [...prevMessages, aiMessage]);
    };




    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const action = event.currentTarget.getAttribute('data-action');

        if (action) {

            sendMessage(action);

            console.log(`Buton renkli tıklandı: ${action}`);
        }
    };


    const sendMessage = async (eventOrMessage?: React.MouseEvent<HTMLButtonElement> | string) => {
        // Sözleşme onayı kontrolü
        if (!isAgreementAccepted) {
            showInfoAlert('Bilgilendirme', 'Devam etmek için lütfen sözleşmeyi onaylayınız.');
            return;
        }

        // GUID kontrolü ekleyelim
        const chatGuid = sessionStorage.getItem('chatGuid');
        if (!chatGuid) {
            showInfoAlert('Bilgilendirme', 'Lütfen önce bir kategori seçiniz.');
            return;
        }

        let message = "";
        const wasVoiceUsed = (window as any).wasVoiceInput; // Mevcut durumu kaydet

        // Eğer event geldiyse `messageInput` kullanılır, string geldiyse direkt o mesaj
        if (typeof eventOrMessage === "string") {
            message = eventOrMessage;
        } else {
            message = messageInput.trim();
        }

        if (!message) return;

        // Her mesaj gönderiminde ses girişi durumunu sıfırla
        if (typeof window !== 'undefined') {
            (window as any).wasVoiceInput = false;
        }

        setIsLoading(true);

        const userMessage = { sender: 'user', text: message, time: getTime(), isFile: false, fileName: '' };
        setMessages((prevMessages) => [...prevMessages, userMessage]);
        saveMessageToSessionStorage('text', message, 'user', getTime(), null, '');
        setMessageInput('');
        setTimeout(() => {
            scrollToBottom();
        }, 200);

        try {

            const response = await api.post('/api/Chat/SendMessage', {
                newmessage: message,
                botType: sessionStorage.getItem('botType'),
                GUID: sessionStorage.getItem('chatGuid')
            });

            if (response.data.responseStatus) {
                console.log(response.data.type);
                // type 9 kontrolü ve diğer durumlar için güncelleme
                setInputsDisabled(response.data.type === 9);

                // Diğer type kontrolleri
                if (response.data.type === 8) {
                    sessionStorage.clear();
                    window.location.reload();
                    return;
                } else if (response.data.type === 5) {
                    window.location.href = 'https://www.happ.health';
                    return;
                }

                const aiMessageContent = response.data.response;

                // HTML etiketlerini temizle
                const plainText = aiMessageContent.replace(/<[^>]*>/g, '');

                // wasVoiceInput kontrolünü messageInput'tan al
                if (wasVoiceUsed) {  // wasVoiceUsed kullan
                    setTimeout(() => {
                        if (window.speechSynthesis && plainText) {
                            const utterance = new SpeechSynthesisUtterance(plainText);
                            utterance.lang = 'tr-TR';
                            window.speechSynthesis.speak(utterance);
                        }
                    }, 500);
                }

                if (response.data.buttons && response.data.buttons.length > 0) {
                    const renkler = ['blue', 'orange', 'green'];
                    const buttonElements = response.data.buttons.map((button: { title: string }, idx: number) => (
                        <button
                            key={button.title}
                            data-action={button.title}
                            onClick={handleButtonClick}
                            className={`sabit-btn ${renkler[idx % 3]}`}
                        >
                            {button.title}
                        </button>
                    ));

                    const combinedContent = (
                        <div>
                            <p>{response.data.response}</p>
                            <div>{buttonElements}</div>
                        </div>
                    );

                    setMessages((prevMessages) => [...prevMessages, { sender: 'ai', text: combinedContent, time: getTime() }]);
                    const contentString = ReactDOMServer.renderToString(combinedContent);
                    saveMessageToSessionStorage('text', contentString, 'ai', getTime(), null, '');
                } else {
                    setMessages((prevMessages) => [...prevMessages, { sender: 'ai', text: aiMessageContent, time: getTime() }]);
                    saveMessageToSessionStorage('text', aiMessageContent, 'ai', getTime(), null, '');
                }
            } else {
                if (response.data.isFileNotUploaded) {
                    const aiMessage = { sender: 'ai', text: response.data.responseMessage, time: getTime() };
                    setMessages((prevMessages) => [...prevMessages, aiMessage]);
                    saveMessageToSessionStorage('text', response.data.responseMessage, 'ai', getTime(), null, '');
                    setTimeout(() => {
                        handleOpenPopup();
                    }, 2000);
                } else {
                    showInfoAlert('Bilgilendirme', response.data.responseMessage);
                }
            }
        } catch (error: any) {

            if (error?.response?.status === 403) {
                showConfirmAndRedirectAlert(
                    'Üye olun veya giriş yapın',
                    'Randevu alma işlemlerine devam etmek için üye olmanız veya giriş yapmanız gerekmektedir. Üye olmak veya giriş yapmak ister misiniz?',
                    'Evet',
                    'Hayır',
                    'https://www.happ.health/ai/chat/login'
                );
            } else if (error?.response?.status === 401) {
                showErrorAlert('Token refresh et', '');
            } else {
                showErrorAlert('Bilinmeyen bir hata oluştu', '');
            }
        } finally {
            setIsLoading(false);
        }

        setTimeout(() => {
            scrollToBottom();
        }, 500);
    };


    // Chat ekranını aşağı kaydır
    const scrollToBottom = () => {

        if (messageBoxRef.current) {
            messageBoxRef.current.scrollTop = messageBoxRef.current.scrollHeight;
        }
    };


    const setDefaultMessage = (id: number) => {
        // Sözleşme onayı kontrolü
        if (!isAgreementAccepted) {
            showInfoAlert('Bilgilendirme', 'Devam etmek için lütfen sözleşmeyi onaylayınız.');
            return;
        }

        let userMessage = { sender: 'user', text: '', time: getTime(), isFile: false, fileName: '' };
        let aiMessage = { sender: 'ai', text: null as React.ReactNode, time: getTime(), isFile: false, fileName: '' };

        switch (id) {
            case 1:
                userMessage.text = 'Hangi Diyet';
                aiMessage.text = '<span> Hangi diyet fonksiyonu ile size özel diyet listenizi alabilir ve uygulayabilirsiniz.  <a target ="_blank" rel = "noopener noreferrer" href = "https://www.happ.health/ai/hangi-diyet" className = "text-primary"> Hangi diyet fonksiyonuna yönlenmek için tıklayınız</></span>';
                break;

            // case 2:
            //     userMessage.text = 'Branşımı Bilmiyorum';
            //     aiMessage.text = '<span>Branşımı bilmiyorum fonksiyonu ile şikayetlerinizi girdikten sonra sizi en doğru bölüme yönlendirecektir. Lütfen şikayetlerinizi belirtiniz.  </span>';
            //     sessionStorage.setItem('botType', "3");
            //     break;

            case 3:
                userMessage.text = 'Sonucumu Değerlendir';
                aiMessage.text = '<span>Lütfen bir dosya yükleyin.</span>';
                sessionStorage.setItem('botType', "1");
                setTimeout(() => handleOpenPopup(), 500);
                break;

            case 4:
                userMessage.text = 'Randevu Almak İstiyorum';
                aiMessage.text = '<span>Randevu Alma fonksiyonuna hoşgeldiniz.</span>';
                handleStartChat();
                sessionStorage.setItem('botType', "2");
                break;

            default:
                userMessage.text = 'Bilinmeyen işlem.';
                aiMessage.text = '<span>Bu işlem için bir aksiyon tanımlanmamış.</span>';
                break;
        }

        // `aiMessage.text` değerini düz metin olarak al
        // const aiMessageText = typeof aiMessage.text === 'string'
        //     ? aiMessage.text
        //     : (aiMessage.text?.props?.children && Array.isArray(aiMessage.text.props.children)
        //         ? aiMessage.text.props.children.join(' ')
        //         : aiMessage.text?.props?.children || '');

        saveMessageToSessionStorage('text', userMessage.text, 'user', getTime(), null, '');
        saveMessageToSessionStorage('text', aiMessage.text.toString(), 'ai', getTime(), null, '');

        setMessages((prevMessages) => [...prevMessages, userMessage, aiMessage]);

        setTimeout(() => {
            scrollToBottom();
        }, 500);
    };

    const toggleListening = () => {
        if (!recognition) {
            showErrorAlert('Hata', 'Tarayıcınız ses tanıma özelliğini desteklemiyor.');
            return;
        }

        if (isListening) {
            recognition.stop();
        } else {
            recognition.start();
        }
        setIsListening(!isListening);
    };

    const handleTranscript = (text: string) => {
        setMessageInput(text);
    };

    const handleStartChat = async () => {
        // Sözleşme onayı kontrolü
        if (!isAgreementAccepted) {
            showInfoAlert('Bilgilendirme', 'Devam etmek için lütfen sözleşmeyi onaylayınız.');
            return;
        }

        try {
            const response = await api.post('/api/Chat/StartChat');

            // Guid'i kaydet
            if (response.data.guid) {
                sessionStorage.setItem('chatGuid', response.data.guid);
            }

            if (response.data.responseStatus) {
                // Type 9 kontrolü ekle
                setInputsDisabled(response.data.type === 9);

                const aiMessageContent = response.data.response;

                // AI yanıtını sesli oku (eğer ses girişi kullanıldıysa)
                if ((window as any).wasVoiceInput && (window as any).speakResponse) {
                    const plainText = aiMessageContent.replace(/<[^>]*>/g, '');
                    (window as any).speakResponse(plainText);
                }

                if (response.data.buttons && response.data.buttons.length > 0) {
                    const renkler = ['blue', 'orange', 'green'];
                    const buttonElements = response.data.buttons.map((button: { title: string }, idx: number) => (
                        <button
                            key={button.title}
                            data-action={button.title}
                            onClick={handleButtonClick}
                            className={`sabit-btn ${renkler[idx % 3]}`}
                        >
                            {button.title}
                        </button>
                    ));

                    const combinedContent = (
                        <div>
                            <p>{response.data.response}</p>
                            <div>{buttonElements}</div>
                        </div>
                    );

                    setMessages((prevMessages) => [...prevMessages, { sender: 'ai', text: combinedContent, time: getTime() }]);
                    const contentString = ReactDOMServer.renderToString(combinedContent);
                    saveMessageToSessionStorage('text', contentString, 'ai', getTime(), null, '');
                } else {
                    setMessages((prevMessages) => [...prevMessages, { sender: 'ai', text: aiMessageContent, time: getTime() }]);
                    saveMessageToSessionStorage('text', aiMessageContent, 'ai', getTime(), null, '');
                }
            } else {
                showInfoAlert('Bilgilendirme', response.data.responseMessage);
            }
        } catch (error: any) {

            if (error?.response?.status === 403) {
                showConfirmAndRedirectAlert(
                    'Üye olun veya giriş yapın',
                    'Randevu alma işlemlerine devam etmek için üye olmanız veya giriş yapmanız gerekmektedir. Üye olmak veya giriş yapmak ister misiniz?',
                    'Evet',
                    'Hayır',
                    'https://www.happ.health/ai/chat/login'
                );
            } else if (error?.response?.status === 401) {
                showErrorAlert('Token refresh et', '');
            } else {
                showErrorAlert('Bilinmeyen bir hata oluştu', '');
            }
        }
    };

    return (

        <div >

            <div id="chat-container">
                <div className="card mx-auto no-border">
                    <div className="chat-topbar">
                        <div className="chat-topbar-left">
                            <img src="https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/741384eb-f43d-407b-7f26-d48bcb1f3100/public" alt="HappAI Logo" className="chat-topbar-logo" />
                            <span className="chat-topbar-title">HappAI</span>
                        </div>
                        <button className="chat-topbar-close" onClick={() => window.location.reload()} aria-label="Kapat">
                            <span style={{ fontWeight: 600, fontSize: '1.1rem' }}>×</span>
                        </button>
                    </div>
                    <div ref={messageBoxRef} className="card-body p-3 pb-5 chat-body" id="chat-messagebox-body" >
                        {isLoading && <Loader />} {/* Yükleniyorsa Loader göster */}
                        <div className="d-flex align-items-baseline mb-4">

                            <div>
                                <div className="pe-2">
                                    <div>
                                        <div className="card  card-text d-inline-block p-2 px-3 m-1 chat-bubble bot">Merhaba ben HappAI . Sana yardımcı olabilmem için hangi kategoride destek almak istediğine tıklayabilir misin ?</div>
                                    </div>

                                </div>

                            </div>
                        </div>


                        <div className="d-flex align-items-baseline mb-4">

                            <div>
                                <div className="pe-2">
                                    <div>
                                        <div onClick={() => setDefaultMessage(3)} className="sabit-btn blue">Sonucumu Değerlendir</div>
                                    </div>

                                </div>
                                <div className="pe-2">
                                    <div>
                                        <div onClick={() => setDefaultMessage(1)} className="sabit-btn orange">Hangi Diyet?</div>
                                    </div>

                                </div>
                                {/* <div className="pe-2">
                                    <div>
                                        <div onClick={() => setDefaultMessage(2)} className="card chat-button card-text d-inline-block p-2 px-3 m-1">Branşımı Bilmiyorum</div>
                                    </div>

                                </div> */}
                                <div className="pe-2">
                                    <div>
                                        <div onClick={() => setDefaultMessage(4)} className="sabit-btn green">Randevu Almak İstiyorum</div>
                                    </div>

                                </div>

                            </div>
                        </div>


                        <div id="chat-messagebox-body">

                            {messages.map((msg, index) => (

                                <div
                                    key={index}
                                    className={`d-flex mb-3 ${msg.sender === 'user' ? 'justify-content-end text-end' : 'justify-content-start'}`}
                                >
                                    {msg.isFile ? (
                                        <div className={`d-flex align-items-baseline mb-4 message ${msg.sender === 'user' ? 'user' : 'chat'}`}
                                        >
                                            <div className="pe-2">
                                                <div>
                                                    <div className="file-container">
                                                        <div className="file-icon png">
                                                            <i className="far fa-file-image" aria-hidden="true"></i>
                                                        </div>
                                                        <div className="file-info">
                                                            <span className="file-name">{msg.fileName}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="chat-time">{msg.time}</div>
                                                </div>
                                            </div>

                                        </div>
                                    ) : (
                                        <div className={`d-flex align-items-baseline message`}
                                        >
                                            <div className="pe-2">
                                                {typeof msg.text === 'string' ? (
                                                    <div
                                                        className={`chat-bubble ${msg.sender === 'user' ? 'user' : 'bot'}`}
                                                        dangerouslySetInnerHTML={{ __html: msg.text }}
                                                    ></div>
                                                ) : (
                                                    <div className={`chat-bubble ${msg.sender === 'user' ? 'user' : 'bot'}`}>
                                                        {msg.text}
                                                    </div>
                                                )}
                                                <div>
                                                    <div className="chat-time">{msg.time}</div>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>




                    </div>

                    <FileUploadPopup
                        isVisible={isPopupVisible}
                        onClose={handleClosePopup}
                        onUploadSuccess={handleUploadSuccess}
                    />
                    <UserAgreementPopup />


                    <div className="position-fixed card-footer bg-white position-absolute w-100 bottom-0 m-0 p-1" >
                        <div className="chat-inputbar">
                            <button onClick={handleOpenPopup} className="chat-inputbar-file" type="button">
                                <img src="https://imagedelivery.net/mlgbP0181FH-5b9hEejSQw/06aed643-d5a2-4deb-9693-9dbf632e4700/public" alt="Dosya Gönder" />
                            </button>
                            <input
                                type="text"
                                className="chat-inputbar-input"
                                placeholder="Mesaj yazın..."
                                value={messageInput}
                                onChange={(e) => setMessageInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                                disabled={inputsDisabled}
                            />
                            <div className="chat-inputbar-icons">
                                <VoiceInput
                                    onTranscript={handleTranscript}
                                    disabled={inputsDisabled}
                                />
                                <button
                                    onClick={sendMessage}
                                    className="chat-inputbar-iconbtn"
                                    disabled={inputsDisabled}
                                    type="button"
                                >
                                    <img src="/images/send-icon.svg" alt="Gönder" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>






    );
};

export default Chat;

